import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import {
  Input, DatePickerInput, SimpleCheckboxInput, Typography,
} from '../../..';

import { RelatedItemCard, RelatedActions } from '..';

export interface Props {
    removeLesson: (lessonId: number)=> void,
    setData: (index: number, moduleLesson: any) => void,
    order: number,
    index: number,
    getLesson: any,
    moduleLesson: any
}

const ModuleLessonCard: React.FC<Props> = ({
  order,
  index,
  getLesson,
  removeLesson,
  moduleLesson,
  setData,
  ...props
}: Props) => {
  const lesson = getLesson(parseInt(moduleLesson.aula_id));

  const removeAction = () => {
    removeLesson(lesson.id);
  };

  useEffect(() => {
    setData(index, moduleLesson);
  }, [index, moduleLesson, order, setData]);

  return (
    <RelatedItemCard order={order} title={lesson?.name}>
      <Box display="grid" gridTemplateColumns="100px 10% 30% 30% auto" width="100%">
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="text" size="1.25rem" fontWeight="bold">
            {lesson?.materialsCount}
          </Typography>
          <Box display="none">
            <Input name="id" />
            <Input name="aula_id" />
          </Box>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center">
          <SimpleCheckboxInput name="optativa" />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center">
          <DatePickerInput name="data_publicacao" />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box display="flex" maxWidth="100px">
            <Input type="number" name="liberar_apos_dias" />
            {' '}
            Dias
          </Box>
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <RelatedActions removeAction={removeAction} />
        </Box>
      </Box>
    </RelatedItemCard>
  );
};

// LessonMaterialMultipleInputWrapper.defaultProps = {
//   background: '#FFF'
// }

export { ModuleLessonCard };
